export default __webpack_public_path__ + "static/media/LAS0280.34I-32603_-17864_0.5cbe9d5f.jpg";